<template>
    <b-overlay
            :show="loading"
            rounded="sm"
    >
        <b-row>
            <b-col>
                <b-card-actions
                    :actionCollapse="true"
                        title="جزئیات محصول"
                >
                    <b-form
                            ref="productform"
                            @submit.prevent
                    >
                        <b-row>

                            <b-col
                                    class="mt-2 form-size"
                                    md="6"
                                    offset-md="3"
                            >
                                        <b-row>

                                            <b-col
                                                class="image"
                                                cols="12"
                                            >
                                                <b-media class="mb-2">
                                                    <template #aside>
                                                        <b-avatar
                                                            ref="previewEl"
                                                            :src="Form.Image"
                                                            size="90px"
                                                            rounded
                                                            button
                                                            @click="$refs.refInputEl.click()"
                                                        />
                                                    </template>
                                                    <input
                                                        :ref="'refInputEl'"
                                                        type="file"
                                                        class="d-none"
                                                        name="Image"
                                                        @input="imageRenderer($event)"
                                                    >
                                                    <b-row>
                                                        <b-col md="12">
                                                            <b-form-group
                                                                label="عنوان"
                                                                label-for="Title"
                                                                class="mb-0"
                                                            >
                                                                <b-form-input
                                                                    id="Title"
                                                                    v-model="Form.Title"
                                                                    name="Title"
                                                                    autocomplete="off"
                                                                />
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-media>
                                            </b-col>

                                          <b-col md="12">
                                            <b-form-group
                                                label="زیرنویس"
                                                label-for="Caption"
                                            >
                                              <b-form-input
                                                  v-model="Form.Caption"
                                                  autocomplete="off"
                                                  name="Caption"
                                              />
                                            </b-form-group>
                                          </b-col>


                                          <b-col md="4">
                                                <b-form-group
                                                    label="دسته بندی"
                                                    label-for="ProductCategoryId"
                                                >
                                                    <product-category
                                                        v-model="Form.ProductCategoryId"
                                                        :multiple="false"
                                                        :clearable="false"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group
                                                    label="برند"
                                                    label-for="BrandId"
                                                >
                                                    <brand
                                                        v-model="Form.BrandId"
                                                        :multiple="false"
                                                        :clearable="false"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group
                                                    label="گارانتی"
                                                    label-for="GuarantyId"
                                                >
                                                    <guaranty
                                                        v-model="Form.GuarantyId"
                                                        :multiple="false"
                                                        :clearable="true"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col
                                                cols="12"
                                                class="mt-50"
                                            >
                                                <b-form-group>
                                                    <b-form-checkbox
                                                        v-model="Form.HasVariety"
                                                        name="Visibility"
                                                        value="true"
                                                        class="custom-control-primary"
                                                    >
                                                        محصول دارای تنوع رنگی می باشد.
                                                    </b-form-checkbox>
                                                </b-form-group>
                                            </b-col>

                                            <b-col
                                                cols="12"
                                                class="mb-50"
                                            >
                                                <b-form-group>
                                                    <b-form-checkbox
                                                        v-model="Form.IsAuction"
                                                        name="Visibility"
                                                        value="true"
                                                        class="custom-control-primary"
                                                    >
                                                        در قسمت تخفیفات باورنکردنی نمایش داده شود.
                                                    </b-form-checkbox>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group
                                                    label="وضعیت"
                                                    label-for="Status"
                                                >
                                                    <v-select
                                                        v-model="Form.Status"
                                                        :options="enums('ProductStatus')"
                                                        dir="rtl"
                                                        label="text"
                                                        name="Status"
                                                        :clearable="false"
                                                        :reduce="x => x.value"
                                                        :disabled="Form.HasVariety"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group label="قیمت"
                                                              label-for="Price">
                                                    <b-input-group append="تومان">
                                                        <cleave
                                                            v-model="Form.Price"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                            :disabled="Form.HasVariety"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group label="تخفیف"
                                                              label-for="Discount">
                                                    <b-input-group append="تومان">
                                                        <cleave
                                                            v-model="Form.Discount"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                            :disabled="Form.HasVariety"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group
                                                    label="تعداد"
                                                    label-for="Quantity"
                                                >
                                                    <b-form-input
                                                        v-model="Form.Quantity"
                                                        autocomplete="off"
                                                        type="number"
                                                        name="Quantity"
                                                        :disabled="Form.HasVariety"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4">
                                                <b-form-group
                                                    label="بارکد"
                                                    label-for="Barcode"
                                                >
                                                    <b-form-input
                                                        v-model="Form.Barcode"
                                                        autocomplete="off"
                                                        name="Barcode"
                                                        :disabled="Form.HasVariety"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="4"></b-col>

                                            <b-col md="3">
                                                <b-form-group
                                                    label="حداقل تعداد سفارش"
                                                    label-for="MinOrderQuantity"
                                                >
                                                    <b-form-input
                                                        v-model="Form.MinOrderQuantity"
                                                        autocomplete="off"
                                                        type="number"
                                                        name="MinOrderQuantity"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="3">
                                                <b-form-group
                                                    label="حداکثر تعداد سفارش"
                                                    label-for="MaxOrderQuantity"
                                                >
                                                    <b-form-input
                                                        v-model="Form.MaxOrderQuantity"
                                                        autocomplete="off"
                                                        type="number"
                                                        name="MaxOrderQuantity"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                          <b-col md="3">
                                            <b-form-group label="زمان آماده سازی"
                                                          label-for="Preparation">
                                              <b-input-group append="روز">
                                                <cleave
                                                    v-model="Form.Preparation"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options"
                                                />
                                              </b-input-group>
                                            </b-form-group>
                                          </b-col>

                                            <b-col md="3">
                                                <b-form-group label="هزینه بسته بندی"
                                                              label-for="PackagingPrice">
                                                    <b-input-group append="تومان">
                                                        <cleave
                                                            v-model="Form.PackagingPrice"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="3">
                                                <b-form-group label="وزن"
                                                              label-for="Weight">
                                                    <b-input-group append="گرم">
                                                        <cleave
                                                            v-model="Form.Weight"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3">

                                                <b-form-group label="طول"
                                                              label-for="Length">
                                                    <b-input-group append="سانتی‌متر">
                                                        <cleave
                                                            v-model="Form.Length"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3">
                                                <b-form-group label="عرض"
                                                              label-for="Width">
                                                    <b-input-group append="سانتی‌متر">
                                                        <cleave
                                                            v-model="Form.Width"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3">
                                                <b-form-group label="ارتفاع"
                                                              label-for="Height">
                                                    <b-input-group append="سانتی‌متر">
                                                        <cleave
                                                            v-model="Form.Height"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options"
                                                        />
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="12">
                                                <b-form-group
                                                    label="تگ ها"
                                                    label-for="Tag"
                                                >
                                                    <b-form-tags
                                                        v-model="Form.Tag"
                                                        name="Tag"
                                                        placeholder=""
                                                        add-button-text="افزودن"
                                                        add-button-variant="outline-primary"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group
                                                    label="توضیحات"
                                                    label-for="Description"
                                                >
                                                    <b-form-textarea
                                                        id="Description"
                                                        v-model="Form.Description"
                                                        name="Description"
                                                        rows="5"
                                                        no-resize
                                                    />
                                                </b-form-group>

                                            </b-col>

                                            <b-col cols="12">
                                                <div class="divider divider-solid">
                                                    <div class="divider-text" style="font-weight: 600;">مشخصات</div>
                                                </div>
                                            </b-col>

                                            <b-col cols="12">
                                                <b-row>
                                                    <b-col
                                                        md="2"
                                                    >
                                                        <b-form-group
                                                            label="قابل فیلتر"
                                                        />
                                                    </b-col>
                                                    <b-col
                                                        md="3"
                                                    >
                                                        <b-form-group
                                                            label="عنوان"
                                                        />
                                                    </b-col>
                                                    <b-col
                                                        md="5"
                                                    >
                                                        <b-form-group
                                                            label="توضیحات"
                                                        />
                                                    </b-col>

                                                </b-row>
                                                <b-row
                                                    v-for="(item, index) in Form.ProductInfo"
                                                    :key="index"
                                                >

                                                    <b-col md="2">
                                                        <b-form-group
                                                        >
                                                            <b-form-checkbox
                                                                v-model="item.ShowInFilter"
                                                                class="custom-control-primary"
                                                            />
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col md="3">
                                                        <b-form-group
                                                        >
                                                            <b-form-input
                                                                v-model="item.Title"
                                                                autocomplete="off"
                                                            />
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col md="5">
                                                        <b-form-group
                                                        >
                                                            <b-form-input
                                                                v-model="item.Description"
                                                                autocomplete="off"
                                                            />
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col
                                                        md="2"
                                                        class="mb-1"
                                                        style="display: flex; align-items: flex-end;"
                                                    >
                                                        <template v-if="ProductInfoRemoveId !== index">
                                                            <b-button
                                                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                                variant="outline-danger"
                                                                class="btn-icon rounded-circle"
                                                                @click="removeProductInfo(index)"
                                                            >
                                                                <feather-icon
                                                                    icon="TrashIcon"
                                                                />
                                                            </b-button>
                                                        </template>
                                                        <template v-else>
                                                            <b-button
                                                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                                class="btn-icon rounded-circle"
                                                                variant="outline-primary"
                                                                @click="cancelProductInfo"
                                                            >
                                                                <feather-icon icon="XIcon"/>
                                                            </b-button>
                                                            <b-button
                                                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                                class="btn-icon rounded-circle ml-1"
                                                                variant="outline-primary"
                                                                @click="confirmProductInfo"
                                                            >
                                                                <feather-icon icon="CheckIcon"/>
                                                            </b-button>
                                                        </template>
                                                    </b-col>


                                                </b-row>
                                            </b-col>

                                            <b-col class="mt-50">
                                                <b-button
                                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                    variant="gradient-info"
                                                    @click="addProductInfo"
                                                >
                                                    <feather-icon
                                                        icon="PlusIcon"
                                                        class="mr-25"
                                                    />
                                                    <span>افزودن</span>
                                                </b-button>
                                            </b-col>
















                                            <b-col cols="12">
                                                <div class="divider divider-solid mb-0">
                                                    <div class="divider-text" style="font-weight: 600;">گالری</div>
                                                </div>
                                            </b-col>
                                            <div
                                                v-for="(item, index) in Form.ProductGallery"
                                                :key="item.Id"
                                                class="px-1 mb-1"
                                            >
                                                <b-avatar
                                                    ref="previewEl"
                                                    :src="item.Url"
                                                    size="120px"
                                                    rounded
                                                    class="foodrecipes-image mt-1"
                                                >
                                                </b-avatar>
                                                <b-button
                                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                    variant="outline-secondary"
                                                    style="margin-top: 0.5rem;"
                                                    class="btn-icon video-remove"
                                                    @click="removeGallery(item)"
                                                >
                                                    <feather-icon
                                                        icon="XIcon"
                                                        size="14"
                                                    />
                                                </b-button>
                                            </div>

                                            <input
                                                ref="refGalley"
                                                type="file"
                                                class="d-none"
                                                accept="image/*"
                                                @change="galleryRenderer($event)"
                                            >

                                            <div class="px-1 mb-1 mt-1">
                                                <div
                                                    class="activity-upload-video"
                                                    @click="$refs.refGalley.click()"
                                                >
                                                    <div class="activity-upload-video-icon">
                                                        <feather-icon
                                                            size="24"
                                                            icon="UploadIcon"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <b-col cols="12">
                                                <hr>
                                            </b-col>
                                            <b-col class="mt-1 mb-2 text-center">
                                                <b-button
                                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                    type="submit"
                                                    variant="primary"
                                                    class="mr-1"
                                                    @click="save"
                                                >
                                                    ذخیره
                                                </b-button>
                                                <b-button
                                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                    variant="outline-secondary"
                                                    @click="back"
                                                >
                                                    بازگشت
                                                </b-button>
                                            </b-col>
                                        </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card-actions>
            </b-col>
        </b-row>

        <b-card-actions v-if="this.Form.Id" title="تنوع" :collapsed="true" :actionCollapse="true">
            <product-color />
        </b-card-actions>
    </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'
import ProductColor from '@/views/menu/product/productcolor.vue'
import Brand from '@/tools/brand.vue'
import Guaranty from '@/tools/guaranty.vue'
import Color from '@/tools/color.vue'
import ZActivityPackage from "@/tools/activitypackage.vue";
import ZActivity from "@/tools/activity.vue";
import uploadFile from "@/tools/uploadFile.vue";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

export default {
    name: 'ProductDetails',
    components: {
        BCardActions,
        uploadFile, ZActivity, ZActivityPackage,
        ProductCategory,
        Brand,
        Guaranty,
        Color,
        ProductColor
    },
    data() {
        return {
            Form: {
                Id: null,
                Title: null,
                Image: null,
                Description: null,
                ProductCategoryId: [],
                BrandId: null,
                Weight: null,
                Wage: null,
                Profit: null,
                Stock: null,
                Status: 0,
                ProductGallery: [],
                ProductInfo: [],
                ProductColor: [],
                IsMultiColor: false,
                HasVariety: false,
                IsAuction: false,
            },
            GalleryFile: [],
            loading: false,
            galleryId: 0,
            ProductInfoRemoveId: null,
            options: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
                numeralDecimalScale: 4,
            },
            collapsed: false
        }
    },
    created() {
        if (this.$route.params.id) {
            this.Form.Id = this.$route.params.id
            this.get()
        }
    },
    methods: {
        save() {
            let url = this.$api.product.add
            if (this.$route.params.id) {
                url = this.$api.product.update
            }

            const formData = new FormData(this.$refs.productform)
            formData.append('Id', this.Form.Id)
            formData.append('ProductCategoryId', this.Form.ProductCategoryId)

            if (this.Form.BrandId) {
                formData.append('BrandId', this.Form.BrandId)
            }

            if (this.Form.GuarantyId) {
                formData.append('GuarantyId', this.Form.GuarantyId)
            }

            if (this.Form.Price) {
                formData.append('Price', this.Form.Price.replaceAll(',', ''))
            }

            if (this.Form.Discount) {
                formData.append('Discount', this.Form.Discount.replaceAll(',', ''))
            }

            if (this.Form.Weight) {
                formData.append('Weight', this.Form.Weight.replaceAll(',', ''))
            }

            if (this.Form.Length) {
                formData.append('Length', this.Form.Length.replaceAll(',', ''))
            }

            if (this.Form.Width) {
                formData.append('Width', this.Form.Width.replaceAll(',', ''))
            }

            if (this.Form.Height) {
                formData.append('Height', this.Form.Height.replaceAll(',', ''))
            }

            if (this.Form.Preparation) {
                formData.append('Preparation', this.Form.Preparation.replaceAll(',', ''))
            }

            if (this.Form.PackagingPrice) {
                formData.append('PackagingPrice', this.Form.PackagingPrice.replaceAll(',', ''))
            }

                formData.append('HasVariety', this.Form.HasVariety)
                formData.append('IsAuction', this.Form.IsAuction)
                formData.append('Quantity', this.Form.Quantity)
                formData.append('Barcode', this.Form.Barcode)

            formData.append('Status', this.Form.Status)


            this.Form.ProductInfo.forEach((item, index) => {
                if ((item.Title && item.Title.trim()) || (item.Description && item.Description.trim())) {
                    formData.append(`ProductInfo[${index}].Title`, item.Title)
                    formData.append(`ProductInfo[${index}].Description`, item.Description)
                    formData.append(`ProductInfo[${index}].ShowInFilter`, item.ShowInFilter)
                }
            })

            this.Form.ProductColor.forEach((item, index) => {
                if ((item.Title && item.Title.trim()) || (item.Description && item.Description.trim())) {
                    formData.append(`ProductInfo[${index}].Title`, item.Title)
                    formData.append(`ProductInfo[${index}].Description`, item.Description)
                }
            })

            this.Form.ProductGallery.forEach((item, index) => {
                formData.append(`ProductGallery[${index}].Id`, item.Id)
                formData.append(`ProductGallery[${index}].Sort`, index)
                if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
                    formData.append(`ProductGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
                }
            })

            this.loading = true
            this.$http.post(
                url, formData,
            )
                .then(() => {
                    this.back()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        imageRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.Form.Image = fileReader.result
            }
        },
        galleryRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.galleryId++

                this.Form.ProductGallery.push({Url: fileReader.result, Id: this.galleryId})
                this.GalleryFile.push({Url: event.target.files[0], Id: this.galleryId})
            }
        },
        removeGallery(item) {
            this.Form.ProductGallery = this.Form.ProductGallery.filter(x => x.Id !== item.Id)
        },
        addProductInfo() {
            this.Form.ProductInfo.push({
                Title: '', Description: '',
            })
        },
        removeProductInfo(index) {
            this.ProductInfoRemoveId = index
        },
        confirmProductInfo() {
            this.Form.ProductInfo.splice(this.ProductInfoRemoveId, 1)
            this.ProductInfoRemoveId = null
        },
        cancelProductInfo() {
            this.ProductInfoRemoveId = null
        },
        addProductColor() {
            console.log(this.Form)
            this.Form.ProductColor.push({Price: null, Discount: null, Quantity: null, MinOrderQuantity: null, MaxOrderQuantity: null})
        },
        get() {
            this.loading = true
            this.$http.post(
                this.$api.product.get, {
                    Id: this.Form.Id,
                },
            )
                .then(res => {
                    this.loading = false
                    this.Form = res.data

                    if (this.Form.ProductGallery.length) {
                        this.galleryId = this.Form.ProductGallery.sort((a, b) => {
                            return b.Id - a.Id
                        })[0].Id
                        this.Form.ProductGallery.sort((a, b) => {
                            return a.Sort - b.Sort
                        })
                    }
                })
        },
    },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
